export default __webpack_public_path__ + "static/media/Fidelity-Computer-Crime-insurance-policy-nov-2025.9c91126a.pdf";